exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-group-control[data-v-e12c9bf2] {\n  overflow: auto;\n  width: 100%;\n}\n", ""]);

// exports
